module.exports = __webpack_public_path__ + "img/arrow-left.519c9e81.svg";